import { takeEvery, put, call, all, fork } from 'redux-saga/effects';
import envDetect from '@tcc/env-detect';
import { shouldUseMocks } from '../utils/mocks';
import { queryParam } from '../utils/queryString';
import { receiveFeatures } from '../actions/featureActions';
import { requestFeature } from '../requesters/featureRequester';
import { REQUEST_FEATURES } from '../constants/actionTypes';

/**
 * Get Feature Flag API call - See if the user has access to this feature
 * @param {Object} action
 * @param {String[]} action.flagNames
 * @param {Number} action.userId
 * @param {String} action.email
 * @return {void}
 */
export function* getFeatures(action) {
  const { flagNames } = action;

  // If in local & using mocks, return false for features specified in query param, true otherwise
  if (!envDetect.isEC2()) {
    const declinedFeatures = queryParam('declinedFeatures');
    const declinedFeaturesArr =
      shouldUseMocks() && declinedFeatures ? declinedFeatures.split(',') : [];

    const flagValues = flagNames.map((flagName) => declinedFeaturesArr.includes(flagName)
      ? {
        value: false,
      }
      : {
        value: true,
        'source-key': 'internal-users',
      });
    return yield put(receiveFeatures(flagNames, flagValues));
  }

  try {
    const responses = yield all(
      flagNames.map((flagName) => call(requestFeature, flagName))
    );

    return yield put(receiveFeatures(flagNames, responses));
  } catch (error) {
    return yield put(receiveFeatures([], []));
  }
}

/**
 * Waits for the return of the REQUEST_FEATURE action event and calls the getFeature saga
 * @return {void}
 */
export function* getFeaturesWatcher() {
  yield takeEvery(REQUEST_FEATURES, getFeatures);
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(getFeaturesWatcher);
}
